"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hex_1 = require("./hex");

var padding_1 = require("./padding");

function hexToBuffer(value) {
  if (!hex_1.isHexStrict(value)) {
    throw new Error('Not a 0x formatted hex string');
  }

  if (value.length % 2 !== 0) {
    value = padding_1.leftPad(value, value.length - 1);
  }

  return Buffer.from(value.slice(2), 'hex');
}

exports.hexToBuffer = hexToBuffer;

function bufferToHex(value) {
  return '0x' + value.toString('hex');
}

exports.bufferToHex = bufferToHex;